module.exports = __webpack_public_path__ + "img/process-4.928f87b2.jpg";